/* eslint-disable jsx-a11y/anchor-is-valid */

import { FaInstagram, FaLinkedin, FaTwitter, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import { FiFacebook, FiPhone } from "react-icons/fi";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="text-slate-50"    
>
      <footer>
        <div className="flex flex-wrap gap-2 max-w-7xl mx-auto px-4">
          <div className="flex-1 basis-[10rem]">
            <Link to="/" className="flex-shrink-0 flex-align-center gap-x-1">
              {/* <BiBuildingHouse className="text-3xl text-primary" />
              <h1 className="hidden md:block">poolhomecare</h1> */}
                <img src="/images/logo/logo-white.svg" className="h-20 w-auto rounded-full" alt="" />
            </Link>
            <div className="mt-3">
            <p className="mt-4 text-sm">
              Pool Home Care: Your trusted partner in premium swimming pool
              design, installation, and maintenance. We offer comprehensive
              solutions to keep your pool pristine and luxurious.
            </p>
            
              <div className="gap-5 my-6 flex-center-center">
              <a
                href="https://wa.me/918319579035?text=Hello%20Pool%20Home%20Care%2C%20I%20would%20like%20to%20know%20more%20about%20your%20services."
                className="icon-box bg-dark-light hover:bg-hover-color-dark"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp size={25} className="text-green-400" />
              </a>
              <a
                href="tel:+918319579035"
                className="icon-box bg-dark-light hover:bg-hover-color-dark"
              >
                <FiPhone size={20} />
              </a>
              <a
                href="mailto:ankitgurjar96175@gmail.com"
                className="icon-box bg-dark-light hover:bg-hover-color-dark"
              >
                <FaEnvelope  size={20}/>
              </a>
              <a
                href="https://www.instagram.com/pool_home_care_/?igsh=NXc1NGp2eHJ6NWZx&utm_source=qr"
                target="blank"
                className="icon-box bg-dark-light hover:bg-hover-color-dark"
              >
                <FaInstagram  size={20}/>
              </a>

               
              </div>
              <div className="flex-1 basis-[10rem]">
         
          </div>

            </div>
          </div>

          <div className="flex-1 basis-[10rem]">
  <h2 className="text-xl font-semibold ">Services</h2>
  <ul>
    <li className="my-3">
      <a
        href="/services/turnkey-jobs"
        className="text-muted hover:text-orange-500 transition"
      >
        Turnkey Jobs
      </a>
    </li>
    <li className="my-3">
      <a
        href="/services/consultancy"
        className="text-muted hover:text-orange-500 transition"
      >
        Consultancy
      </a>
    </li>
    <li className="my-3">
      <a
        href="/services/renovation"
        className="text-muted hover:text-orange-500 transition"
      >
        Renovation
      </a>
    </li>
    <li className="my-3">
      <a
        href="/services/chemical-spares"
        className="text-muted hover:text-orange-500 transition"
      >
        Chemical & Spares
      </a>
    </li>
    <li className="my-3">
      <a
        href="/services/maintenance"
        className="text-muted hover:text-orange-500 transition"
      >
        Maintenance Services
      </a>
    </li>
    <li className="my-3">
      <a
        href="/services/pool-care"
        className="text-muted hover:text-orange-500 transition"
      >
        Pool Care
      </a>
    </li>
  </ul>
</div>

          <div className="flex-1 basis-[10rem]">
            <h2 className="text-xl font-semibold">Quick Links</h2>
            <ul>
              <li className="my-3">
                <Link to="/" className="hover:text-orange-500 transition">
                  Home
                </Link>
              </li>
              <li className="my-3">
                <Link
                  to="/swimming-pools"
                  className="hover:text-orange-500 transition"
                >
                  Swimming Pools
                </Link>
              </li>
              <li className="my-3">
                <Link
                  to="/services"
                  className="hover:text-orange-500 transition"
                >
                  Services
                </Link>
              </li>
              <li className="my-3">
                <Link
                  to="/premium-works"
                  className="hover:text-orange-500 transition"
                >
                  Premium Works
                </Link>
              </li>
              <li className="my-3">
                <Link to="/gallery" className="hover:text-orange-500 transition">
                  Gallery
                </Link>
              </li>
              <li className="my-3">
                <Link
                  to="/products"
                  className="hover:text-orange-500 transition"
                >
                  Products
                </Link>
              </li>
              <li className="my-3">
                <Link
                  to="/contact"
                  className="hover:text-orange-500 transition" >
                  Contact US
                </Link>
              </li>
            </ul>
          </div>

        
          <div className="flex-1 basis-[10rem]">
            <h2 className="text-xl font-semibold">Office Address</h2>
            <address className="mt-4 not-italic">
              <a
                href="https://maps.app.goo.gl/17385MNovL8mDMPt6"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline block"
              >
                1734, Gauri Nagar Main Rd, Veena Nagar,<br />
                DDU Nagar, Sukhliya, Indore, Madhya Pradesh 452003
              </a>
            </address>
            <h2 className="text-xl font-semibold mt-6">Contact Us</h2>
            <p className="mt-2">Mr. Ankit Gurjar</p>
            <a
              href="tel:+918319579035"
              className="hover:underline block"
              rel="noopener noreferrer" 
            >
              +91 8319579035
            </a>
            <a
              href="mailto:ankitgurjar96175@gmail.com"
              className="hover:underline block"
             rel="noopener noreferrer" 
            >
              ankitgurjar96175@gmail.com
            </a>
            <h2 className="text-xl font-semibold mt-6">Other Links</h2>
            <ul className="mt-2">
              <li>
                <a href="/faqs" className="hover:underline text-muted">
                  FAQ's
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
      <div className=" py-2 mt-3 text-center border-t text-white border-dark">
      <p>&copy; <span className="text-primary">Pool Home Care</span> | All Rights Reserved</p>
      </div>
    </div>
  );
};

export default Footer;
